/*
 * @Author: bbqin
 * @Date: 2022-07-14 14:38:31
 * @LastEditTime: 2022-08-24 15:22:18
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\FastExtend\utils\path.js
 * (混沌)足够多的方案才能接近真实的结果。
 */

import { ViewModel, pageTo, getAppUrl, getParentWindow, getTopWindow } from '@platform/api';
import * as constant from '../const';
import * as log from './log';

const ExtendModuleName = constant.name;
const ReleaseConfigFileName = constant.releaseConfigFileName;
//liuming CONFIG引用修改
const isPageModal = constant.isPageModal;

/**
 * 判断路径是否存在
 * @param {*} src 
 * @returns 
 */
const srcriptAlreadyExist = src => {
    let allScript = document.getElementsByTagName('script');
    let srcriptUrl = Array.from(allScript).map(element => {
        return element.getAttribute('src');
    });
    let index = srcriptUrl.findIndex(val => val === src);
    return index !== -1;
};

/**
 * 获取地址的hash
 */
function getHash() {
    // hash 示例
    // "ifr=/nccloud/resources/price/price/adjustprice/main/index.html#/list&c=403000800&p=403000800_list&ar=0001Z81000000003QAX4&n=价格调整单&b1=供应链&b2=销售价格&b3=销售调价"
    let hash = '';
    if (isPageModal) {
        let pageStore = getAppUrl().pageurl;
        hash = decodeURIComponent(decodeURIComponent(pageStore));
    } else {
        hash = decodeURIComponent(decodeURIComponent(getTopWindow()?.location?.hash));
    }

    log.warning(hash, '未找到hash');

    return hash;
}

/**
 * 查找resources加载的文件路径里某一层级的文件名
 * n:Number 在resources的第几层
 */
function getUrlPathName(n) {
    let hash = getHash();

    // 云融合 ../../../
    // 老版本 ifr=\/nccloud\/resources
    // 客开本地 /
    let matchStr = hash.match(/\.\.\/\.\.\/\.\.\/\.\.\/(\S*).html/) || hash.match(/ifr=\/nccloud\/resources\/(\S*).html/) || hash.match(/ifr=\/(\S*).html/);

    log.warning(matchStr, '未找到匹配的领域地址');

    let urlPathArr = matchStr && matchStr[1] && matchStr[1].split('/');
    return urlPathArr[n];
}

/**
 * 获取客开的目标地址关键字
 * @param {单据信息} billinfo 
 */
function getExtendPathKeyboard(billinfo = {}) {
    let domainCode = getUrlPathName(0),
        moduleCode = getUrlPathName(1),
        nodePath = getUrlPathName(2),
        appcode = billinfo.appcode || pageTo.getAppCode(),
        pagecode = billinfo.pagecode || pageTo.getPageCode();

    return {
        domainCode,
        moduleCode,
        appcode,
        nodePath,
        pagecode,
    };
}

/**
 * 获取扩展路径(向下兼容)
 */
function getExtendUrl(billinfo = {}) {

    let {
        domainCode,
        moduleCode,
        appcode,
        nodePath,
        pagecode,
    } = getExtendPathKeyboard(billinfo);

    let appCodeUrl = domainCode && moduleCode && appcode && pagecode ? `extend_${domainCode}/${moduleCode}/${appcode}/${pagecode}` : null;
    let appPathUrl = domainCode && moduleCode && nodePath && pagecode ? `extend_${domainCode}/${moduleCode}/${nodePath}/${pagecode}` : null;

    log.warning(appCodeUrl, '客开地址目录缺失', billinfo, domainCode, moduleCode, appcode, pagecode);
    log.warning(appPathUrl, '客开地址目录缺失', billinfo, domainCode, moduleCode, nodePath, pagecode);

    return {
        appPathUrl,
        appCodeUrl,
    };
}

/**
 * 完整路径的前缀
 * @returns 
 */
function getPathPrefix() {
    let prefix = '/';

    let href = window?.location?.href || '';
    // 云融合 ../../../
    // 老版本 \/nccloud\/resources
    // 客开本地 /
    if (/\.\.\/\.\.\/\.\.\/\.\.\/(\S*).html/.test(href)) {
        prefix = '../../../../';
    } else if (/\/nccloud\/resources\/(\S*).html/.test(href)) {
        prefix = '/nccloud/resources/';
    } else {
        prefix = '/';
    }

    return prefix;
}

/**
 * 获取客开配置文件的关键目录
 * @param {单据信息} billinfo 
 * @returns 
 */
function getExtendTargetCatalogue(billinfo = {}) {
    let {
        domainCode,
        moduleCode,
        appcode,
        nodePath,
        pagecode,
    } = getExtendPathKeyboard(billinfo);

    let prefix = getPathPrefix();

    let appCodeUrl = domainCode && moduleCode && appcode && pagecode ? `${prefix}${ReleaseConfigFileName}/${domainCode}/${moduleCode}/${appcode}/${pagecode}.json` : null;
    let appPathUrl = domainCode && moduleCode && nodePath && pagecode ? `${prefix}${ReleaseConfigFileName}/${domainCode}/${moduleCode}/${nodePath}/${pagecode}.json` : null;

    log.warning(appCodeUrl, '客开配置地址目录缺失', billinfo, domainCode, moduleCode, appcode, pagecode);
    log.warning(appPathUrl, '客开配置地址目录缺失', billinfo, domainCode, moduleCode, nodePath, pagecode);

    return {
        appPathUrl,
        appCodeUrl,
    };
}

export default {
    getExtendUrl,
    getExtendPathKeyboard,
    srcriptAlreadyExist,
    getExtendTargetCatalogue,
    getPathPrefix,
};